import { render, staticRenderFns } from "./Pie.vue?vue&type=template&id=11383a50&scoped=true"
import script from "./Pie.vue?vue&type=script&lang=ts"
export * from "./Pie.vue?vue&type=script&lang=ts"
import style0 from "./Pie.vue?vue&type=style&index=0&id=11383a50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11383a50",
  null
  
)

export default component.exports